import Keycloak from 'keycloak-js'
import keycloakConfig from './constants/Keycloak.config' 

const keycloak = new Keycloak(keycloakConfig)

export default keycloak
 